// src/data/claimBars.js
//
// Record 600 (claim categories, Bob 10/7). CLAIM BARS - what an agreement's own text says may NOT be grieved or
// claimed (or may be only on a stated condition), keyed to the Box 1 claim categories in box1Guided.js.
//
// Bob, 2026-10-07: when the member picks a category his agreement bars, show a clear warning BEFORE filing that
// quotes the bar verbatim with its rule. The member can still file - information, never a block (the screen's
// existing convention). Nothing here stops, hides or changes a claim.
//
// SOURCE OF THE ROWS: data/YCP_CARRIER_VIOLATION_CATEGORIES_2026-10-07.md section 6, "Claim bars", the verified table
// (lines 873-884) ONLY. The "Further bars" paragraph (line 886) is citations not re-read and is NOT used.
// Every quote below was re-read against the agreement file at the line cited on 2026-10-07 and is reproduced
// verbatim (PD-16): line breaks collapsed to single spaces, and a word broken across a line ("24-" / "hour")
// printed whole. The one shortening (Metro-North, a page footer and the next page's heading inside the sentence)
// is marked " ... " in the quote. scripts/test-claim-categories.mjs re-checks every quote against its file:lines.
//
// CORRECTION TO THE SOURCE DOCUMENT, found while re-reading: its BN Rule 2(F) row quotes line 240 as "Yardmaster may
// progress any claim or grievance on the basis of not receiving an uninterrupted" - the line is a fragment; the
// sentence (lines 238-241) reads "... and no Yardmaster may progress any claim ...". The fragment alone states the
// opposite of the rule. The full sentence is quoted here.
//
// agreementKey is the agreement string the claim screen carries (AGREEMENT_LOOKUP in agreementData.js). A CSX key
// also covers its three territory keys ("<key> — <territory>"). Metro-North and Tacoma Rail are NOT agreements on
// the platform today (no AGREEMENT_LOOKUP entry): their rows are kept with agreementKey null so the record is
// whole, and they show to no one until those agreements are added and the key is filled in here.
//
// Pure module: no React, no Firestore.


import { CLAIM_BARS } from './claimBarsTable';   // section 737: the table is installation content (ruling 321)
export { CLAIM_BARS };

const s = (v) => (v == null ? '' : String(v).trim());

// The bars that apply to this claim's agreement and category. [] when none (or when either is missing).
export function barsFor(agreementKey, categoryId) {
  const a = s(agreementKey), c = s(categoryId);
  if (!a || !c) return [];
  return CLAIM_BARS.filter(b => b.categoryId === c && b.agreementKey &&
    (a === b.agreementKey || a.startsWith(b.agreementKey + ' — ')));
}

// The fixed words above the quotes on the screen.
export const BAR_HEADING = 'Your agreement limits claims of this kind';
export const BAR_NOTE = 'You can still file this claim. This is information, never a block - read the words below and talk to your Local Chairperson.';
